export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "A dashed white lane means:",
    options: [
      "Changing of lanes is prohibited",
      "Changing lanes is allowed",
      "Overtaking is not allowed",
    ],
    correctAnswer: "Changing lanes is allowed",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
